import React, { Suspense, useEffect, useRef, useState } from "react";
import Accordion from "../../components/Accordion/Accordion";
import FormCreator from "../../components/Forms/FormCreator";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import Buttons from "../../components/ui/button/Buttons";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { useGetCriteriaBySGBPApplicationIdMutation, useLazyGetDropDownsForProductsAndServicesQuery, useLazyGetMainContactPersonDetailsForSGBPByRepresentativeIdQuery, useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery, useLazyGetSGBPTaskDetailsByIdQuery, useNotifyOrApproveSGBPApplicationMutation, useSendClarificationForSGBPApplicationMutation, useUpdateSGBPMembershipApplicationMutation } from "../../app/services/productAndService/productAndServiceApi";
import { setAllDropDownField, setmainContactFields, setProductDetailsDropDown } from "./utils/dropdownUtils";
import { setFieldParameter } from "./utils/setFieldParameter";
import { SGBPApplicationFormData } from "./data/SGBPApplicationFormData";
import { saveAs } from 'file-saver'
import { useLazyGetPDFQuery, useStoreBase64ImageMutation, useUploadPDFMutation } from "../../app/services/common/commonApi";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import { APIUrl } from "../../utils/API/fetchBaseQuery";
import SwalAlert from "../../services/swalService/SwalService";
import { useGetAllDropdownForSubCategoryByL1Mutation, useGetAllDropdownForTypeByL2Mutation } from "../../app/services/Crud/crudApi";
import ToastService from "../../services/toastService/ToastService";
import { useAddAuditLogForSGBPApplcation } from "../../utils/AuditLogQuery/addAuditLog";

const ViewSGBPApplicationFormFeature = () => {
  const formRef = useRef();
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0;
  const navigate = useNavigate();
  const { error, success } = SwalAlert();
  const [isShowModal, setIsShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImageShow, setIsImageShow] = useState(false);
  const [productCatFile, setProductCatFile] = useState(null);
  const [productPicture, setProductPicture] = useState(null);
  const [formData, setFormData] = useState(SGBPApplicationFormData);
  const [showClarificationModal, setShowClarificationModal] = useState(false);
  const [clarificationComments, setClarificationComments] = useState("");
  const [isNotify, setIsNotify] = useState(false);

  const [getSGBPTaskDetailsById, { data: taskDetailsData, isLoading: taskDetailsIsLoading, isFetching: taskDetailsIsFetching, }] = useLazyGetSGBPTaskDetailsByIdQuery()
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading, },] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [mainContactPersonDropdown, { data: mainContactPersonDropdownData, isLoading: mainContactPersonDropdownLoading, },] = useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery();
  const [getMainContactPersonDetails, { data: getMainContactPersonDetailsData, isLoading: getMainContactPersonDetailsLoading, },] = useLazyGetMainContactPersonDetailsForSGBPByRepresentativeIdQuery();
  const [saveMainImage, { isSuccess: isSuccessImage, isLoading: isLoadingImage, data: profileImageUpload }] = useStoreBase64ImageMutation();
  const [updateSGBPMembershipApplication, { data: applicationFormResponse, isLoading: applicationFormLoading, },] = useUpdateSGBPMembershipApplicationMutation();
  const [getPDF] = useLazyGetPDFQuery();
  const [uploadPDF] = useUploadPDFMutation();
  const [subCategoryByL1Dropdown, { data: subCategoryByL1DropdownData, isLoading: subCategoryByL1DropdownLoading, },] = useGetAllDropdownForSubCategoryByL1Mutation();
  const [typeByL2Dropdown, { data: typeByL2DropdownData, isLoading: typeByL2DropdownLoading, },] = useGetAllDropdownForTypeByL2Mutation();
  const [sendClarification, { isSuccess: isSuccessSend, isLoading: isLoadingSend, data: sendClarificationData }] = useSendClarificationForSGBPApplicationMutation();
  const [getCriteriaBySGBPApplicationId, { isSuccess: isSuccessCriteria, isLoading: isLoadingCriteria, data: criteriaData }] = useGetCriteriaBySGBPApplicationIdMutation();
  const [notifyOrApproveSGBPApplication, { isSuccess: isSuccessNotify, isLoading: isLoadingNotify, data: notifyOrApproveData }] = useNotifyOrApproveSGBPApplicationMutation();
  const {addAuditLog} = useAddAuditLogForSGBPApplcation();

  const handleOrganazationImageUpload = async (data, ext) => {
    const { base64Data, fileName } = data;
    if (ext === "pdf") {
      let formData = new FormData();
      formData.append("file", data)
      formData.append("storagePath", "ProductCatalogue");
      try {
        const response = await uploadPDF(formData);
        setProductCatFile(response.data)
      } catch (e) {
        error(e, "Error");
      }

    } else {
      let saveFileRequest = {
        fileName: fileName,
        fileStr: base64Data,
        storagePath: "ProductCatalogue",
      }
      const response = await saveMainImage(saveFileRequest);
      setProductCatFile(response.data);

    }
  }

  const handleProfileUpload = async (data, ext) => {
    const { base64Data, fileName } = data;
    let saveFileRequest = {
      fileName: fileName,
      fileStr: base64Data,
      storagePath: "ProductCatalogue",
    }
    const response = await saveMainImage(saveFileRequest);
    setProductPicture(response.data);
  }


  const handleFormFieldChange = async (dataField, value) => {
    //  ProductCateloueName  productCateloueFileName == upload file 
    let form = { ...formData };
    form.initialState = { ...form.initialState };
    const selectedValue = value?.value ?? null;
    let categoryL1 = formRef.current.getFieldValue("serviceCategory");
    let manufacturesName = formRef.current.getFieldValue("nameOfManufacturer");
    let manufacturesAdd = formRef.current.getFieldValue("addressOfManufacturer");
    if (dataField === "mainContactPerson") {
      setFormData(prev => ({ ...prev, initialState: { ...prev.initialState, mainContactPerson: selectedValue } }));
      if (selectedValue) {
        getMainContactPersonDetails(selectedValue);
      }
    }
    else if (dataField === "serviceCategory") {
      const apiResponse = await subCategoryByL1Dropdown({ CategoryL1Id: value?.value });
      const filterDropdown = apiResponse?.data?.map((item) => ({
        value: item.id,
        label: item.name
      }));
      let updatedFormData = { ...formData, initialState: { ...formData.initialState, serviceCategory: value?.value, subCategory: null, productType: null, } };
      updatedFormData = { ...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "subCategory" ? { ...field, fieldSetting: { ...field.fieldSetting, options: filterDropdown, }, } : field), };
      setFormData(updatedFormData);
    }
    else if (dataField === "subCategory") {
      const apiResponse = await typeByL2Dropdown({ SubCategoryL2Id: value?.value });
      const filterDropdown = apiResponse?.data?.map((item) => ({
        value: item.id,
        label: item.name
      }));
      let updatedFormData = { ...formData, initialState: { ...formData.initialState, serviceCategory: categoryL1, subCategory: value.value, productType: null, } };
      updatedFormData = { ...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "productType" ? { ...field, fieldSetting: { ...field.fieldSetting, options: filterDropdown, }, } : field), };
      setFormData(updatedFormData);
    }
    else if (dataField == "productCateloueName") {
      const extension = value?.name?.split('.').pop().toLowerCase();
      handleOrganazationImageUpload(value, extension);
      let updatedFormData = { ...formData, initialState: { ...formData.initialState, productCateloueName: value?.fileName || value?.name, } };
      updatedFormData = { ...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "productCateloueName" ? { ...field, fieldSetting: { ...field.fieldSetting, isDownloadable: extension == "pdf" ? true : false, viewImage: extension == "pdf" ? false : true, }, } : field), };
      setFormData(updatedFormData);
    }
    else if (dataField == "productPictureName") {
      const extension = value?.name?.split('.').pop().toLowerCase();
      handleProfileUpload(value, extension);
      let updatedFormData = { ...formData, initialState: { ...formData.initialState, productPictureName: value?.fileName || value?.name, } };
      setFormData(updatedFormData);
    }
    else if (dataField === "sameAsManufacturer") {
      let updatedFormData = { ...formData, initialState: { ...formData.initialState, nameOfManufacturingPlant: value == true ? manufacturesName : "", addressofManufacturingPlant: value == true ? manufacturesAdd : "", sameAsManufacturer: value, } };
      setFormData(updatedFormData);
    } else {
      // update field value safely
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
    }
  };


  const openModal = () => {
    setIsModalOpen(true);
  }

  const handleCloseModal = () => {
    setIsShowModal(false);
    setIsModalOpen(false);
    setIsImageShow(false);
  };


  const handleViewImage = (data, dataField) => {
    if (dataField == "productPictureName") {
      setIsImageShow(true);
    } else {
      setIsModalOpen(true);
    }
  }

  const handleDownload = async (data, dataField) => {
    let request = {
      type: "ProductCatalogue",
      fileName: productCatFile?.fileName ? productCatFile?.fileName : taskDetailsData?.productCateloueFileName,
    }
    const response = await getPDF(request);
    saveAs(response?.data?.fileData, response?.data?.fileName);
  }

  const handleClear = (data, dataField) => {
    let updatedForm = { ...formData };
    if (!updatedForm) { return; }

    if (dataField === "speakersCVSFile") {
      updatedForm.initialState.speakersCVSFile = null;
    }
    else if (dataField === "eventProgrammeFile") {
      updatedForm.initialState.eventProgrammeFile = null;
    }
    setFormData(updatedForm);
  };

  const handleSubmit = () => {
    let form = formRef.current.getFormData();
    if (!form) {
      error("Please fill in all mandatory fields to continue.", "");
      return;
    }

    let req = {
      sgbcProductInformationId: taskDetailsData?.sgbpProductInformationId,
      sgbcCorporateMemberId: taskDetailsData?.sgbcCorporateMemberId,
      sgbcCorporateRepresentativeId: form?.mainContactPerson || null,
      applicantsRoleId: form?.applicantRole?.value || form?.applicantRole,
      categoryL1Id: form?.serviceCategory || null,
      subCategoryL2Id: form?.subCategory || null,
      typeL3Id: form?.productType?.value || form?.productType,
      productCateloueName: form?.productCateloueName || null,
      productCateloueFileName: productCatFile?.fileName || form?.productCateloueFileName,
      productPictureName: form?.productPictureName || null,
      productPictureFileName: productPicture?.fileName || form?.productPictureFileName,
      productsGreenFeatures: form?.productsGreenFeatures || null,
      nameOfManufacturer: form?.nameOfManufacturer || null,
      addressOfManufacturer: form?.addressOfManufacturer || null,
      sameAsManufacturer: form?.sameAsManufacturer || false,
      nameOfManufacturingPlant: form?.sameAsManufacturer ? form?.nameOfManufacturer : form?.nameOfManufacturingPlant || null,
      addressofManufacturingPlant: form?.addressofManufacturingPlant || null,
      placeofManufacturing: form?.placeofManufacturing?.value || form?.placeofManufacturing,
      CriteriaId: form?.criteria?.value || form?.criteria,
    }
    updateSGBPMembershipApplication(req);
  }

  const handleSendClarification = () => {
    let req = {
      SGBPProductInformationId: editID,
      SGBCCorporateMemberId: taskDetailsData?.sgbcCorporateMemberId,
      notes: clarificationComments
    }
    sendClarification(req);
  }

  const handleCallL2andL3type = async (taskDetailsData) => {
    let { categoryL1Id, subCategoryL2Id } = taskDetailsData;
    const apiResponseL2 = await subCategoryByL1Dropdown({ CategoryL1Id: categoryL1Id });
    const filterDropdownL2 = apiResponseL2?.data?.map((item) => ({ ...item, dropdownName: "categoryKey" }));
    const apiResponseL3 = await typeByL2Dropdown({ SubCategoryL2Id: subCategoryL2Id });
    const filterDropdownL3 = apiResponseL3?.data?.map((item) => ({ ...item, dropdownName: "subCategoryKey" }));
    let data = [...filterDropdownL2, ...filterDropdownL3]
    setProductDetailsDropDown(data, "categoryKey", "subCategoryKey");
  }



  const handleNofityApprove = () => {
    setIsNotify(true);
    let req = {
      SGBPProductInformationId: editID,
    }
    notifyOrApproveSGBPApplication(req);
  }

  useEffect(() => {
    productsAndServicesDropdown()
    if (editID > 0) {
      getSGBPTaskDetailsById(editID);
    }
  }, [editID])

  useEffect(() => {
    if (!productsAndServicesDropDownsLoading && productsAndServicesDropDownsData) {
      setAllDropDownField(productsAndServicesDropDownsData, setFormData);
    }
  }, [productsAndServicesDropDownsLoading, productsAndServicesDropDownsData]);

  useEffect(() => {
    if (!taskDetailsIsLoading && taskDetailsData) {
      let request = {
        CategopryL1Id: taskDetailsData?.categoryL1Id,
        SubCategopryL2Id: taskDetailsData?.subCategoryL2Id,
        TypeL3Id: taskDetailsData?.typeL3Id,
      }
      if (!taskDetailsData?.criteriaId) {
        getCriteriaBySGBPApplicationId(request);
      }
      const extension = taskDetailsData?.productCateloueFileName?.split('.').pop().toLowerCase();
      handleCallL2andL3type(taskDetailsData);
      let updatedFormData = { ...formData, formFields: formData?.formFields?.map(field => field.id === "productCateloueName" ? { ...field, fieldSetting: { ...field.fieldSetting, isDownloadable: extension == "pdf" ? true : false, viewImage: extension == "pdf" ? false : true, }, } : field), };
      setFieldParameter(taskDetailsData);
      setFormData(updatedFormData);
      mainContactPersonDropdown(taskDetailsData?.sgbcCorporateMemberId);
    }
  }, [taskDetailsIsLoading, taskDetailsData]);

  useEffect(() => {
    if (!isLoadingCriteria && criteriaData) {
      let updatedFormData = { ...formData };
      updatedFormData = { ...updatedFormData.initialState, criteria: criteriaData?.criteriaId || null, }
      setFormData(prev => ({ ...prev, initialState: { ...prev.initialState, ...updatedFormData } }));
    }
  }, [isSuccessCriteria, isLoadingCriteria, criteriaData]);

  useEffect(() => {
    if (!mainContactPersonDropdownLoading && mainContactPersonDropdownData) {
      setmainContactFields(mainContactPersonDropdownData, setFormData);
    }
  }, [mainContactPersonDropdownLoading, mainContactPersonDropdownData]);

  useEffect(() => {
    if (!getMainContactPersonDetailsLoading && getMainContactPersonDetailsData) {
      setFormData(prev => ({
        ...prev,
        initialState: {
          ...prev.initialState,
          mainPhoneNumberID: getMainContactPersonDetailsData?.contactNumberCountryId,
          mainContactPhone: getMainContactPersonDetailsData?.contactNumber,
          mainContactEmail: getMainContactPersonDetailsData?.email,
        }
      }));
    }
  }, [getMainContactPersonDetailsLoading, getMainContactPersonDetailsData]);

  useEffect(() => {
    if (!applicationFormLoading && applicationFormResponse) {

      if (!applicationFormResponse.hasError) {
        !isNotify && success("View SGBP Application is updated!");
        setIsNotify(false);
      }
    }
  }, [applicationFormLoading, applicationFormResponse]);

  useEffect(() => {
    if (isSuccessSend && sendClarificationData) {
      addAuditLog({SGBPSApplicationId: editID || 0,AuditLogDescription: "Clarification Sent For SGBP Application",TriggredTimeStatusId:taskDetailsData?.statusId });
      ToastService.success("Clarification sent successfully!");
      setShowClarificationModal(false);
      setClarificationComments("");
    }
  }, [isLoadingSend, isSuccessSend, sendClarificationData]);

  useEffect(() => {
    if (!isLoadingNotify && isSuccessNotify && notifyOrApproveData) {
      ToastService.success("SGBP Application is notified/approved successfully!");
      handleSubmit();
      addAuditLog({SGBPSApplicationId: editID || 0,AuditLogDescription: "SGBP Application Notified For Self Evaluation",TriggredTimeStatusId:taskDetailsData?.statusId });
      handleBack();
      getSGBPTaskDetailsById(editID);
    }
  }, [isLoadingNotify, isSuccessNotify, notifyOrApproveData])


  const formActionHandler = {
    DOWNLOAD: handleDownload,
    CLEAR: handleClear,
    VIEW_IMAGE: handleViewImage,
  }

  const handleBack = () => {
    navigate(`/viewApplicationTaskList`);
  }

  return (
    <Suspense fallback={<DataLoader />}>
      {mainContactPersonDropdownData ?
        <>
          <Accordion
            title="Company Information"
            className="mb-4"
            button={false}
            accordion={false}
          >
            <div className="row">
              <FormCreator
                ref={formRef}
                {...formData}
                onFormFieldValueChange={handleFormFieldChange}
                onActionChange={formActionHandler}
              />
            </div>
          </Accordion>

          <div className="sgbp-button-section">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="back-btn"
              onClick={handleBack}
            />
            <Buttons
              buttonText="Save"
              buttonTypeClassName="save-btn"
              onClick={handleSubmit}
              isLoading={!isNotify && applicationFormLoading}
              isDisable={[5,16].includes(taskDetailsData?.statusId)}
            />
            <Buttons
              buttonText="Send Clarification"
              buttonTypeClassName="send-btn"
              onClick={() => { setShowClarificationModal(true) }}
              isDisable={[3, 5, 16].includes(taskDetailsData?.statusId)}
            // isLoading={isLoadingSend}
            />
            <Buttons
              buttonText="Notify/Approve"
              buttonTypeClassName="notify-btn"
              onClick={handleNofityApprove}
              isLoading={isLoadingNotify}
              isDisable={[3, 5, 16].includes(taskDetailsData?.statusId)}
            />
          </div>
        </>
        : <DataLoader />}

      <CenterModel
        show={isShowModal}
        modelTitle="Applicant’s Role"
        handleClose={handleCloseModal}
        className="applicant-role-model"
      >
        <div className="applicant-role-model-content">
          <table>
            <tbody>
              <tr>
                <td>Manufacturer</td>
                <td>
                  The applicant owns the design/brand and manufactures it
                  in-house or by related company
                </td>
              </tr>
              <tr>
                <td>OEM</td>
                <td>
                  The applicant owns then design/brand but outsources the
                  manufacturing to a 3rd party
                </td>
              </tr>
              <tr>
                <td>Distributor</td>
                <td>The applicant is an distributor or reseller</td>
              </tr>
            </tbody>
          </table>
        </div>
      </CenterModel>
      {isModalOpen &&
        <CenterModel
          modelTitle={'View Image'}
          show={"test"}
          handleClose={handleCloseModal}
          onUpload={openModal}
          className={"preview-img-model"}
        >
          <div style={{ width: "550px", height: "550px", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto" }}>
            <img
              src={`${APIUrl}/Common/getImage?type=CompanyLogo&fileName=${productCatFile?.fileName ? productCatFile?.fileName : taskDetailsData?.productCateloueFileName}`}
              alt="Uploaded Image"
              width={"100%"}
              height={"100%"}
            />
          </div>
        </CenterModel>
      }
      {isImageShow &&
        <CenterModel
          modelTitle={'View Image'}
          show={isImageShow}
          handleClose={handleCloseModal}
          // onUpload={}
          className={"preview-img-model"}
        >
          <div style={{ width: "550px", height: "550px", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto" }}>
            <img
              src={`${APIUrl}/Common/getImage?type=CompanyLogo&fileName=${productPicture?.fileName ? productPicture?.fileName : taskDetailsData?.productPictureFileName}`}
              alt="Uploaded Image"
              width={"100%"}
              height={"100%"}
            />
          </div>
        </CenterModel>
      }

      {showClarificationModal && <CenterModel
        show={showClarificationModal}
        handleClose={() => (setShowClarificationModal(false), setClarificationComments(""))}
        modelTitle="Send Clarifications"
      >
        <textarea
          className="form-control mt-2"
          rows="4"
          placeholder=""
          value={clarificationComments}
          onChange={(e) => setClarificationComments(e.target.value)}
        />
        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={() => (setShowClarificationModal(false), setClarificationComments(""))}
          />
          <Buttons
            buttonText="Send"
            buttonTypeClassName="success-btn"
            onClick={handleSendClarification}
            isLoading={isLoadingSend}
          />
        </div>
      </CenterModel>}
    </Suspense>
  );
};

export default ViewSGBPApplicationFormFeature;
